import React from 'react';
export const GuaranteeSection = () => {
  return <section className="bg-familia-bg py-10 md:py-16 px-4 md:px-6" data-id="element-113">
      <div className="max-w-3xl mx-auto w-[92%] md:w-full" data-id="element-114">
        <div className="bg-familia-card border-2 border-familia-gold p-8 md:p-16 rounded-[2rem] md:rounded-[2.5rem] text-center relative overflow-hidden" data-id="element-115">
          <div className="text-5xl md:text-7xl mb-6 md:mb-10" data-id="element-116">🛡️</div>
          <h2 className="text-[22px] sm:text-2xl md:text-4xl font-display font-bold mb-6 md:mb-8 uppercase tracking-wider" data-id="element-117">
            GARANTÍA VITALIDAD 360 — 30 DÍAS
          </h2>
          <div className="space-y-1 md:space-y-2 mb-6 md:mb-10 text-lg sm:text-xl md:text-2xl font-bold" data-id="element-118">
            <p data-id="element-119">🛡️ Garantía de 30 días sin preguntas.</p>
            <p data-id="element-120">Úsalo completo. Si no es lo que esperabas,</p>
            <p data-id="element-121">te devolvemos el 100%. Sin formularios.</p>
            <p data-id="element-122">Sin vueltas.</p>
          </div>
          <p className="text-familia-cyan text-[13px] md:text-sm font-medium mb-6 md:mb-10" data-id="element-123">
            Revisa el material con calma y decide si es lo que estabas buscando
            para organizar el acompañamiento cotidiano.
          </p>
          <div className="inline-block bg-familia-green text-familia-bg font-bold px-5 md:px-6 py-2 rounded-full text-xs md:text-sm" data-id="element-124">
            Material digital · Acceso inmediato · Pago único
          </div>
        </div>
      </div>
    </section>;
};